import { gql } from '@apollo/client/core';

export const QUOTE_ANALYTICS_TOTAL_QUOTE_NUMBER_AND_PRICE = gql`
  query QuoteAnalyticsTotalQuoteNumberAndPrice($where: quote_analytics_bool_exp) {
    quote_analytics_aggregate(where: $where) {
      aggregate {
        sum {
          sell_price
          total_margin
        }
        count
      }
    }
  }
`;

export const QUOTE_ANALYTICS_TOTAL_QUOTE_NUMBER_AND_PRICE_BY_NAME = gql`
  query QuoteAnalyticsTotalQuoteNumberAndPriceByName($where: quote_analytics_bool_exp, $search: String) {
    search_quote_analytics_by_name_aggregate(
      args: { name_search: $search},
      where: $where,
    ) {
      aggregate {
        sum {
          sell_price
          total_margin
        }
        count
      }
    }
  }
`;
